export default {

  setAuthorizationStatus(state, status){
    state.isUserAuthorized = status;
  },

  setAuthToken(state, token){
    state.authToken = token;
  },

  setUserData(state, userData){
    state.userData = userData;
  },

  setSitesList(state, sitesList){
    state.sitesList = sitesList
  },

  setPartnersList(state, partnersList){
    state.partnersList = partnersList
  },

  setMarketsList(state, marketsList){
    state.marketsList = marketsList;
  },

  setDevicesList(state, devicesList){
    state.devicesList = devicesList;
  },

  setLeftSideBarStatus(state, status){
    state.sideBarStatus = status;
  },
  setScrollOffsetY(state, value){
    state.scrollOffsetY = value;
  },

  setURLParams(state, value){
    state.URLparams = value;
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/base/mutations.js